import { create } from 'zustand';

/**
 * Immersive-screen registry.
 *
 * Intentionally-dark, full-bleed "takeover" screens (Finale, share cards,
 * cinematic loaders, the first-run welcome) register here while mounted.
 * AppLayout reads the count and suppresses the bottom nav + bottom scrim so
 * theme-aware light chrome can never paint over a dark screen — this does not
 * rely on z-index, which is unreliable inside an iOS WKWebView scroller using
 * -webkit-overflow-scrolling: touch.
 */
interface ImmersiveState {
  count: number;
  enter: () => void;
  exit: () => void;
}

export const useImmersiveStore = create<ImmersiveState>((set) => ({
  count: 0,
  enter: () => set((s) => ({ count: s.count + 1 })),
  exit: () => set((s) => ({ count: Math.max(0, s.count - 1) })),
}));

export const useIsImmersive = () => useImmersiveStore((s) => s.count > 0);
